// Log Geral oculto temporariamente.
// Pendente implementar TenantIdentifier nos logs para isolar a visualizacao por tenant
// antes de liberar novamente o acesso aos logs.
export default [
  // {
  //   path: '/log',
  //   name: 'log',
  //   component: () => import('@/app-modulo/comuns/log/Log.vue'),
  //   meta: {
  //     resource: 'log',
  //     action: 'read',
  //     pageTitle: 'Log geral',
  //     breadcrumb: [],
  //   },
  // },
]
